import React from 'react';
import { Table, Button } from 'reactstrap';
import Row from '../Row';
import $ from 'jquery';
import DropZoneTable from './DropZoneTable';
import { connect } from 'react-redux';
import UpArrow from '@mui/icons-material/KeyboardArrowUp';
import DownArrow from '@mui/icons-material/KeyboardArrowDown';

class DocumentTypeTable extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentPage: 0,
            numPages: 0,
            pageNumber: 1,
            prevPageLimit: 0,
            pageLimit: 10,
            rowsShown: 9,
            sortConfig: { key: null, direction: 'asc' },
            filters: {
                DocumentType: '',
                Folder: '',
                Description: '',
                SystemDefined: ''
            },
            showFilters: false
        }

        this.goToNextPage = this.goToNextPage.bind(this)
        this.goToPrevPage = this.goToPrevPage.bind(this)
    }

    handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
        filters: {
            ...prevState.filters,
            [key]: value
        },
        currentPage: 0 // optional: reset to first page on filter
        }));
    };

    toggleFilters = () => {
        this.setState((prevState) => ({
            showFilters: !prevState.showFilters
        }));
    };
    
    clearAllFilters = () => {
        this.setState({
            filters: {
            DocumentType: '',
            Folder: '',
            Description: '',
            SystemDefined: ''
            },
            currentPage: 0 // optional: reset to first page
        });
    };

    goToNextPage() {
        const { logs = [] } = this.props;
        const totalFiltered = logs.filter(file => {
            const { filters } = this.state;
            const matches = (field, value) =>
            field?.toString().toLowerCase().includes(value.toLowerCase());
            return (
            matches(file.DocumentType, filters.DocumentType) &&
            matches(file.Folder, filters.Folder) &&
            matches(file.Description?.en, filters.Description) &&
            matches(file.SystemDefined?.toString(), filters.SystemDefined)
            );
        }).length;

        const maxPage = Math.max(0, Math.ceil(totalFiltered / this.state.rowsShown) - 1);

        if (this.state.currentPage < maxPage) {
            this.setState((prevState) => ({
            currentPage: prevState.currentPage + 1
            }));
        }
    }


    goToPrevPage() {
        if (this.state.currentPage > 0) {
            this.setState((prevState) => ({
            currentPage: prevState.currentPage - 1
            }));
        }
    }

    onSort = (key) => {
        this.setState((prevState) => {
            const direction =
            prevState.sortConfig.key === key && prevState.sortConfig.direction === 'asc'
                ? 'desc'
                : 'asc';

            return {
            sortConfig: { key, direction }
            };
        });
    };


    renderSortableFilterableHeader = (filterKey, onSort, labelKey, labelFallback) => {
      const isSorted = this.state.sortConfig.key === filterKey;
      const sortArrow = isSorted
      ? this.state.sortConfig.direction === 'asc'
        ? <UpArrow />
        : <DownArrow />
      : null;

      const label = this.getLocalizedLabel(labelKey, labelFallback);

      return (
      <th
        key={filterKey}
        className="s-grid-title-cell"
        style={{ cursor: 'pointer' }}
      >
        <div className="s-grid-title-cell-filter" onClick={() => this.onSort(onSort)}>
          {label} {sortArrow}
        </div>
        <div>
          {this.state.showFilters && (
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder="Start typing to search..."
              value={this.state.filters[filterKey] || ''}
              onMouseDown={(e) => e.stopPropagation()}
              onChange={(e) => this.handleFilterChange(filterKey, e.target.value)}
            />
          )}
        </div>
      </th>
      );
    };

    getLocalizedLabel = (key, fallback) => {
      const labelObj = this.props.userReducer.localisation[key];
      return labelObj?.element_lang || fallback;
    };
    
    
    render() {

        var b = true
        let grid_css
        let id
        let pageignation = <div />

        const { localisation } = this.props.userReducer

        const filtersActive = Object.values(this.state.filters).some(
            val => val.trim() !== ''
        );

        let logsToRender = [...this.props.logs].filter(file => {
            const { filters } = this.state;

            const matches = (field, value) =>
                field?.toString().toLowerCase().includes(value.toLowerCase());

            return (
                matches(file.DocumentType, filters.DocumentType) &&
                matches(file.Folder, filters.Folder) &&
                matches(file.Description?.en, filters.Description) &&
                matches(file.SystemDefined?.toString(), filters.SystemDefined)
            );
        });

        const { sortConfig } = this.state;

        if (sortConfig.key) {
            logsToRender.sort((a, b) => {
                const aVal = sortConfig.key === 'Description' ? a.Description?.en : a[sortConfig.key];
                const bVal = sortConfig.key === 'Description' ? b.Description?.en : b[sortConfig.key];

                if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
                if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }

        const totalFiltered = logsToRender.length;
        const numPages = Math.max(1, Math.ceil(totalFiltered / this.state.rowsShown));
        const currentPage = Math.min(this.state.currentPage, numPages - 1);
        const startItem = currentPage * this.state.rowsShown;
        const endItem = startItem + this.state.rowsShown;
        const paginatedLogs = logsToRender.slice(startItem, endItem);

        const rows = paginatedLogs.map((file, i) => {
        const grid_css = i % 2 === 0 ? "s-grid-row" : "s-grid-row s-record-alt";
        const id = "P" + file._id;

        return (
            <Row
            key={file._id}
            documentTypeEditorPopover
            onRowClicked={this.props.checkChange}
            rightAlign={[5]}
            i={i}
            checkChange={this.props.checkChange}
            refresh={this.props.refresh}
            id={id}
            fileid={file._id}
            tr_css={grid_css}
            filename={file.DocumentType}
            version={file.Description?.en}
            filetype={file.Folder}
            user={file.SystemDefined?.toString()}
            file={file}
            pages={file.Pages}
            columnConfig={this.props.columnConfig}
            />
        );
        });

        if (this.props.logs) {
            pageignation = <div>
                <div class="s-array-topbar-right">
                    <label class="s-pager-range">
                    {this.props.logs.length > 1
                        ? localisation['table_header_records']
                        ? this.props.logs.length +
                            ' ' +
                            localisation['table_header_records'].element_lang
                        : this.props.logs.length + ' Records'
                        : localisation['table_header_record']
                        ? this.props.logs.length +
                        ' ' +
                        localisation['table_header_record'].element_lang
                        : this.props.logs.length + ' Record'}
                    </label>
                    <label class="s-pager-range">{this.props.logs.length > 1 ? localisation['table_header_records'] ? this.props.logs.length + ' ' + localisation['table_header_records'].element_lang : '' : localisation['table_header_record'] ? this.props.logs.length + ' ' + localisation['table_header_record'].element_lang : ''}</label>
                    <label class="s-pager-range">|</label>
                    <label class="s-pager-size-label">Page {currentPage + 1} / {numPages}</label>
                    <div class="s-pager">
                        <a onClick={this.goToPrevPage} class="s-pager-link s-fonticon-btn s-btn-previous"></a>
                        <a onClick={this.goToNextPage} class="s-pager-link s-fonticon-btn s-btn-next"></a>
                    </div>
                    <a onClick={this.props.refresh} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ marginLeft: '10px' }}
                        onClick={this.toggleFilters}
                        title={this.state.showFilters ? 'Hide search filters' : 'Show search filters'}
                    >
                        <i className="fa fa-filter" aria-hidden="true"></i>
                        <span style={{ marginLeft: '5px' }}>
                        {this.state.showFilters ? 'Hide search Filters' : 'Show search Filters'}
                        </span>
                    </button>
                    {filtersActive && (
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={this.clearAllFilters}
                            title="Clear all filter fields"
                            style={{ marginLeft: '10px' }}
                        >
                            <i className="fa fa-times" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                            Clear Filters
                        </button>
                    )}

                </div>
            </div>
        }


        return (
            <div class="s-slot-row">
                {pageignation}
                <Table responsive={true} hover={true} className="s-grid-table-head">
                    <tr onClick={() => {if (typeof this.props.onRowClicked === 'function') {this.props.onRowClicked(this.props.file)}}}>
                        {(this.props.columnConfig?.actions ?? true) && (
                            <th className="s-grid-title-cell s-grid-title-cell-small">
                                <div className="s-grid-title-empty"></div>
                            </th>
                        )}
                        {/* filterKey, onSort, labelKey, labelFallback */}
                        {this.renderSortableFilterableHeader('DocumentType', 'DocumentType', "doc_type_table_header_name", "Document Type")}

                        {this.renderSortableFilterableHeader('Folder', 'Folder', "doc_type_table_header_folder", "Folder")} 

                        {this.renderSortableFilterableHeader('Description', 'Description', "doc_type_table_header_description", "Description")} 

                        {this.renderSortableFilterableHeader('SystemDefined', 'SystemDefined', "doc_type_table_header_system", "SystemDefined")} 

                    </tr>
                </Table>
                <div class="s-grid-slot-body">
                    <DropZoneTable refresh={this.props.refresh} rows={rows} />
                </div>
            </div>
        );
    }
}

export default connect(state => state)(DocumentTypeTable);
